/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningWorkflowsPlanEntriesCreateAdHocPlanEntryRequest,
  FacilityFlowCoreModulesPlanningWorkflowsPlanEntriesCreateAdHocPlanEntryResponse
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getPlanEntries = () => {
/**
 * @summary Create an ad-hoc PlanEntry (Sondertätigkeit) with free-entry pricing.
The entry is added to the schedule and queued for the next invoice for
the object referenced by the task.
 */
const postApiV1PlanningPlanEntriesAdHoc = (
    facilityFlowCoreModulesPlanningWorkflowsPlanEntriesCreateAdHocPlanEntryRequest: FacilityFlowCoreModulesPlanningWorkflowsPlanEntriesCreateAdHocPlanEntryRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsPlanEntriesCreateAdHocPlanEntryResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsPlanEntriesCreateAdHocPlanEntryResponse>(
      {url: `/api/v1/planning/plan-entries/ad-hoc`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningWorkflowsPlanEntriesCreateAdHocPlanEntryRequest
    },
      options);
    }
  return {postApiV1PlanningPlanEntriesAdHoc}};
export type PostApiV1PlanningPlanEntriesAdHocResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanEntries>['postApiV1PlanningPlanEntriesAdHoc']>>>
